import { SimulateCustomPreset } from 'dashboard/models/simulate/preset';
import { ApiModel } from 'lib/interfaces/api';

export const SIMULATE_PRESET_TYPE_NAMES_SHORT: Record<SimulateCustomPreset['type'], string> = {
  [ApiModel.SimulatePresetVerification]: 'Verification',
};
